export default function CTAFooter() {
    return (
        <div className="mt-8 bg-gradient-to-r from-gray-50 to-slate-50 rounded-2xl p-6">
            <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full mb-4">
                    <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Precisa de ajuda?</h3>
                <p className="text-gray-600 text-sm">
                    Se tiver problemas com o download, entre em contato conosco em{' '}
                    <a href="mailto:support@dikaastral.com" className="text-blue-600 hover:text-blue-800 font-medium">
                        support@dikaastral.com
                    </a>
                </p>
            </div>
        </div>
    )
}